export default __webpack_public_path__ + "static/livas-42994ea66ce7311b5ab3110a1173f3d3.jpg";